import { render, staticRenderFns } from "./welcomeTable.vue?vue&type=template&id=12e03624"
import script from "./welcomeTable.vue?vue&type=script&lang=js"
export * from "./welcomeTable.vue?vue&type=script&lang=js"
import style0 from "./welcomeTable.vue?vue&type=style&index=0&id=12e03624&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports